var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ez-modal',_vm._g({ref:"modal"},_vm.$listeners),[_c('div',{staticClass:"modal__image"},[_c('img',{attrs:{"src":_vm.image,"alt":"Image inside a modal"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }